/* SAGLOU · PDP: galería, ampliación, variantes, opciones de pack, cantidad, bolsa y barra fija.
   Todos los importes salen de los datos de Shopify incluidos en la página. */
(function () {
  'use strict';

  function money(c) { return window.SGD ? window.SGD.money(c) : (c / 100).toFixed(2) + ' €'; }
  function say(m, v) { if (window.SGD) window.SGD.say(m, v); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function watchGalleryVideos(track) {
    var videos = track ? Array.prototype.slice.call(track.querySelectorAll('video')) : [];
    function pause(except) {
      videos.forEach(function (video) { if (video !== except && !video.paused) video.pause(); });
    }
    function hidden() { if (document.hidden) pause(); }
    function leaving() { pause(); }
    function playing(event) { pause(document.hidden ? null : event.currentTarget); }
    var observer = null;
    if (videos.length) {
      videos.forEach(function (video) { video.addEventListener('play', playing); });
      document.addEventListener('visibilitychange', hidden);
      window.addEventListener('pagehide', leaving);
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
          });
        }, { threshold: 0 });
        videos.forEach(function (video) { observer.observe(video); });
      }
    }
    return function () {
      pause();
      if (observer) observer.disconnect();
      videos.forEach(function (video) { video.removeEventListener('play', playing); });
      document.removeEventListener('visibilitychange', hidden);
      window.removeEventListener('pagehide', leaving);
    };
  }

  function init(root) {
    if (!root || root.__sgd) return;
    root.__sgd = true;

    /* ================= Galería ================= */
    var track = root.querySelector('[data-sgd-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-sgd-slide]')) : [];
    var prev = root.querySelector('[data-sgd-prev]');
    var next = root.querySelector('[data-sgd-next]');
    var cur = root.querySelector('[data-sgd-current]');
    var mediaStatus = root.querySelector('[data-sgd-media-status]');
    var bar = root.querySelector('[data-sgd-progress]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sgd-thumb]'));
    var index = -1;
    var releaseVideos = watchGalleryVideos(track);
    function unloadGallery(event) {
      if (event.target.contains(root)) {
        releaseVideos();
        document.removeEventListener('shopify:section:unload', unloadGallery);
      }
    }
    document.addEventListener('shopify:section:unload', unloadGallery);

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function go(i, smooth) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth && !reduce.matches ? 'smooth' : 'auto' });
    }
    function update() {
      if (!track || !slides.length) return;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (i === index && cur && cur.textContent === pad(i + 1)) return;
      index = i;
      if (cur) cur.textContent = pad(i + 1);
      if (mediaStatus) mediaStatus.textContent = (slides[i].getAttribute('data-sgd-kind') || 'Imagen') + ' ' + (i + 1) + ' de ' + slides.length;
      if (bar) bar.style.setProperty('--p', ((i + 1) / slides.length * 100) + '%');
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', Number(t.getAttribute('data-sgd-thumb')) === i + 1 ? 'true' : 'false'); });
      slides.forEach(function (s, k) {
        if (k !== i) s.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
      });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.target !== track) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
        if (e.key === 'Home') { e.preventDefault(); go(0, true); }
        if (e.key === 'End') { e.preventDefault(); go(slides.length - 1, true); }
      });
      if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
      if (next) next.addEventListener('click', function () { go(index + 1, true); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-sgd-thumb')) - 1, true); }); });
      window.addEventListener('resize', function () { go(index, false); });
      update();
    }

    /* ================= Ampliación ================= */
    var dlg = root.querySelector('[data-sgd-lightbox]');
    var zooms = Array.prototype.slice.call(root.querySelectorAll('[data-sgd-zoom]'));
    var lbImg = dlg && dlg.querySelector('[data-sgd-lb-img]');
    var lbCount = dlg && dlg.querySelector('[data-sgd-lb-count]');
    var lbStage = dlg && dlg.querySelector('[data-sgd-lb-stage]');
    var lbStatus = dlg && dlg.querySelector('[data-sgd-lb-status]');
    var lbMessage = dlg && dlg.querySelector('[data-sgd-lb-message]');
    var lbRetry = dlg && dlg.querySelector('[data-sgd-lb-retry]');
    var lbIndex = 0, opener = null, lbRequest = 0;
    function big(img) {
      var s = img.currentSrc || img.src;
      var pixels = Math.min(2000, Math.max(960, Math.ceil(window.innerWidth * Math.min(window.devicePixelRatio || 1, 3) / 400) * 400));
      return s.replace(/([?&])width=\d+/, '$1width=' + pixels);
    }
    function imageState(state) {
      lbImg.hidden = state !== 'ready';
      if (lbStage) lbStage.setAttribute('aria-busy', String(state === 'loading'));
      if (lbStatus) lbStatus.hidden = state === 'ready';
      if (lbRetry) lbRetry.hidden = state !== 'error';
      if (lbMessage) lbMessage.textContent = state === 'error' ? 'No hemos podido cargar esta imagen. Puedes reintentarlo o seguir explorando.' : state === 'loading' ? 'Cargando imagen…' : '';
    }
    function show(i) {
      if (!zooms.length) return;
      var request = ++lbRequest;
      lbIndex = (i + zooms.length) % zooms.length;
      var img = zooms[lbIndex].querySelector('img');
      imageState('loading');
      lbImg.alt = img.alt || '';
      lbCount.textContent = (lbIndex + 1) + ' / ' + zooms.length;
      function loaded() {
        if (!lbImg.complete || !lbImg.naturalWidth) return;
        var decoded = lbImg.decode ? lbImg.decode() : Promise.resolve();
        decoded.then(function () {
          if (request === lbRequest) imageState('ready');
        }).catch(function () {
          if (request === lbRequest) imageState('error');
        });
      }
      lbImg.onload = loaded;
      lbImg.onerror = function () { if (request === lbRequest && lbImg.complete) imageState('error'); };
      lbImg.src = big(img);
      if (lbImg.complete && lbImg.naturalWidth) loaded();
    }
    if (dlg && typeof dlg.showModal === 'function') {
      zooms.forEach(function (z, k) {
        z.addEventListener('click', function () {
          opener = z;
          show(k);
          dlg.showModal();
          dlg.querySelector('[data-sgd-lb-close]').focus();
        });
      });
      dlg.querySelector('[data-sgd-lb-close]').addEventListener('click', function () { dlg.close(); });
      if (lbRetry) lbRetry.addEventListener('click', function () { show(lbIndex); dlg.querySelector('[data-sgd-lb-close]').focus(); });
      dlg.querySelector('[data-sgd-lb-prev]').addEventListener('click', function () { show(lbIndex - 1); });
      dlg.querySelector('[data-sgd-lb-next]').addEventListener('click', function () { show(lbIndex + 1); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(lbIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(lbIndex - 1); }
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('sgd-pdp__lb-stage')) dlg.close(); });
      dlg.addEventListener('close', function () { if (opener) opener.focus({ preventScroll: true }); });
      var x0 = 0;
      dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      dlg.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 60) show(lbIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    } else {
      zooms.forEach(function (z) { z.style.cursor = 'default'; });
    }

    /* ================= Variantes y opciones ================= */
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-sgd-variants]') || {}).textContent || '[]'); } catch (e) {}
    var optionSets = Array.prototype.slice.call(root.querySelectorAll('[data-sgd-option]'));
    var add = root.querySelector('[data-sgd-add]');
    var addLabel = root.querySelector('[data-sgd-add-label]');
    var now = root.querySelector('[data-sgd-now]');
    var was = root.querySelector('[data-sgd-was]');
    var save = root.querySelector('[data-sgd-save]');
    var stock = root.querySelector('[data-sgd-stock]');
    var msg = root.querySelector('[data-sgd-msg]');
    var selfPrice = root.querySelector('[data-sgd-self-price]');
    var barSel = root.querySelector('[data-sgd-bar-sel]');
    var barAdd = root.querySelector('[data-sgd-bar-add]');
    var params = new URLSearchParams(window.location.search);
    var current = variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0] ||
      variants.filter(function (v) { return v.available; })[0] || variants[0] || null;
    var mode = 'self';
    var packVariant = null;
    var packTitle = '';
    var packChoice = root.querySelector('[data-sgd-pack-choice]');
    var packSelect = root.querySelector('[data-sgd-pack-variant]');
    var packOptions = [];

    function selectedOptions() {
      return optionSets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, k) { return opts[k] === null || opts[k] === o; });
      })[0] || null;
    }
    function markAvailability() {
      var opts = selectedOptions();
      optionSets.forEach(function (fs, k) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[k] = inp.value;
          var v = findVariant(test);
          inp.closest('.sgd-pdp__swatch').classList.toggle('is-out', !v || !v.available);
        });
        var shown = fs.querySelector('[data-sgd-option-value]');
        if (shown) shown.textContent = opts[k] || '';
      });
    }
    function render() {
      var v = mode === 'pack' ? packVariant : current;
      if (packChoice) packChoice.hidden = mode !== 'pack' || optionSets.length > 0 || packOptions.length < 2;
      if (!v) {
        if (now) now.textContent = 'Combinación no disponible';
        if (was) was.hidden = true;
        if (save) save.hidden = true;
        if (add) { add.disabled = true; add.removeAttribute('data-variant'); addLabel.textContent = 'No disponible'; }
        if (barAdd) barAdd.disabled = true;
        if (barSel) barSel.textContent = 'Combinación no disponible';
        if (stock) { stock.setAttribute('data-state', 'out'); stock.querySelector('span').textContent = 'Elige otra combinación'; }
        return;
      }
      if (now) now.textContent = money(v.price);
      var hasCompare = v.compare && v.compare > v.price;
      if (was) { was.hidden = !hasCompare; was.textContent = hasCompare ? money(v.compare) : ''; }
      if (save) { save.hidden = !hasCompare; save.textContent = hasCompare ? 'Ahorras ' + money(v.compare - v.price) : ''; }
      if (stock) {
        stock.setAttribute('data-state', v.available ? 'in' : 'out');
        stock.querySelector('span').textContent = v.available ? 'Disponible para envío' : 'Agotado por ahora';
      }
      if (add) {
        add.setAttribute('data-variant', v.id);
        add.disabled = !v.available;
        addLabel.textContent = !v.available ? 'Agotado' : (mode === 'pack' ? 'Añadir el pack a la bolsa' : 'Añadir a la bolsa');
      }
      if (selfPrice && current) selfPrice.textContent = money(current.price);
      if (barSel) barSel.textContent = (mode === 'pack' ? packTitle + (packOptions.length > 1 ? ' · ' + v.title : '') + ' · ' : '') + money(v.price);
      if (barAdd) barAdd.disabled = !v.available;
      if (msg) msg.hidden = true;
    }
    optionSets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        var v = findVariant(selectedOptions());
        current = v;
        if (v) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(null, '', u.toString());
          } catch (e) {}
        }
        markAvailability();
        if (mode === 'pack') pickPack(root.querySelector('[data-sgd-opt-pack]:checked'));
        render();
      });
    });
    function pickPack(input) {
      if (!input) return;
      var list = [];
      try { list = JSON.parse(input.getAttribute('data-pack-variants') || '[]'); } catch (e) {}
      var want = current ? current.options : [];
      packOptions = list;
      var selected = want.filter(function (w) { return w && w !== 'Default Title'; });
      var matches = optionSets.length && !current ? [] : selected.length ? list.filter(function (pv) {
        var opts = pv.options || pv.title.split(' / ');
        return selected.every(function (w) { return opts.indexOf(w) !== -1; });
      }) : list;
      // Conserva el color elegido aunque esté agotado; nunca sustituirlo silenciosamente por otro.
      packVariant = matches.filter(function (pv) { return pv.available; })[0] || matches[0] || null;
      packTitle = input.getAttribute('data-pack-title') || '';
      if (packSelect) {
        packSelect.textContent = '';
        list.forEach(function (pv) {
          var option = document.createElement('option');
          option.value = String(pv.id);
          option.textContent = pv.title + (pv.available ? '' : ' · Agotado');
          option.selected = !!packVariant && pv.id === packVariant.id;
          packSelect.appendChild(option);
        });
      }
    }
    if (packSelect) packSelect.addEventListener('change', function () {
      packVariant = packOptions.filter(function (pv) { return String(pv.id) === packSelect.value; })[0] || null;
      render();
      if (packVariant) say('Pack: ' + packVariant.title + ', ' + money(packVariant.price), false);
    });
    root.querySelectorAll('[data-sgd-options] input[type="radio"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (inp.hasAttribute('data-sgd-opt-self')) { mode = 'self'; packVariant = null; packTitle = ''; }
        else { mode = 'pack'; pickPack(inp); }
        render();
        say(mode === 'pack' ? (packVariant ? 'Seleccionado: ' + packTitle + ', ' + packVariant.title + ', ' + money(packVariant.price) : 'Este pack no está disponible con la opción elegida') : 'Seleccionado el producto solo', false);
      });
    });
    if (optionSets.length) markAvailability();
    render();

    /* ================= Cantidad ================= */
    var qtyInput = root.querySelector('[data-sgd-qty-input]');
    function clampQty(n) { return Math.max(1, Math.min(10, parseInt(n, 10) || 1)); }
    var minus = root.querySelector('[data-sgd-qty-minus]');
    var plus = root.querySelector('[data-sgd-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qtyInput.value = clampQty(qtyInput.value - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = clampQty(Number(qtyInput.value) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value); });

    /* ================= Bolsa ================= */
    var busy = false;
    function addToCart() {
      if (!add || add.disabled || busy || !window.SGD) return;
      busy = true;
      var id = add.getAttribute('data-variant');
      var label = addLabel.textContent;
      add.classList.add('is-busy');
      add.setAttribute('aria-busy', 'true');
      addLabel.textContent = 'Añadiendo…';
      if (msg) msg.hidden = true;
      window.SGD.addToCart(id, qtyInput ? qtyInput.value : 1).then(function () {
        add.classList.remove('is-busy');
        add.classList.add('is-done');
        addLabel.textContent = 'Añadido a tu bolsa';
        say('Añadido a tu bolsa', false);
        window.setTimeout(function () { add.classList.remove('is-done'); render(); }, 2400);
      }).catch(function (err) {
        add.classList.remove('is-busy');
        addLabel.textContent = label;
        if (msg) {
          var detail = err && err.message && err.message !== 'error' ? ' (' + err.message + ')' : '';
          msg.textContent = 'No hemos podido añadirlo a la bolsa' + detail + '. Vuelve a intentarlo o ';
          var help = document.createElement('a');
          help.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'pages/contact';
          help.textContent = 'escríbenos';
          msg.appendChild(help);
          msg.appendChild(document.createTextNode('.'));
          msg.hidden = false;
        }
      }).then(function () { busy = false; add.removeAttribute('aria-busy'); });
    }
    if (add) add.addEventListener('click', addToCart);
    if (barAdd) barAdd.addEventListener('click', addToCart);

    /* ================= Barra fija móvil ================= */
    var barEl = root.querySelector('[data-sgd-bar]');
    if (barEl && add) {
      barEl.hidden = false;
      var foot = document.querySelector('footer, .footer');
      var pending = false;
      function sync() {
        pending = false;
        var r = add.getBoundingClientRect();
        var past = r.bottom < 0;
        var footIn = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
        barEl.classList.toggle('is-on', past && !footIn);
      }
      window.addEventListener('scroll', function () { if (!pending) { pending = true; requestAnimationFrame(sync); } }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    /* ================= Código promocional ================= */
    root.querySelectorAll('[data-sgd-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-sgd-copy');
        window.SGD.copy(code).then(function (ok) { say(ok ? 'Código copiado: ' + code : 'Copia el código a mano: ' + code); });
      });
    });
  }

  function boot() { document.querySelectorAll('[data-sgd-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
